// The one element injected into the cinematic header: a "youtube" button that
// switches to the YouTube shell. Renders nothing (null, not an empty element —
// the header's spacing rules count children) unless the server says the user
// is allowlisted AND has enabled the mode in Settings.

import { useNavigate } from "react-router-dom";

import { useYtAccess } from "./api";

export function YoutubeModeButton() {
  const { data } = useYtAccess();
  const navigate = useNavigate();

  if (!data?.eligible || !data.enabled) return null;

  return (
    <button
      type="button"
      className="app-header__btn app-header__btn--outline"
      title="switch to youtube mode (experimental) — rate your own watch history"
      onClick={() => navigate("/youtube")}
    >
      youtube
    </button>
  );
}
